/**
 * Check if the list is after a table
 * @param {Node} doc - The document object
 * @param {Node} list - The list node
 * @param {Object} selection - The selection object
 * @returns {boolean} - True if the list is after a table, false otherwise
 */
const checkIfAfterTable = (doc, list, { from }) => {
    let isAfterTable = false;

    doc.nodesBetween(0, from, (node, _pos, parent) => {
        if (node.type.name === "table") {
            isAfterTable = true;
        }

        if (node === list && isAfterTable) {
            return true;
        } else if (!node.type.name.includes("table") && !node.type.name.includes("listItem")) {
            if (node.type.name !== "paragraph" && !parent.type.name.includes("table")) {
                isAfterTable = false;

                return true;
            }
        }
    });

    return isAfterTable;
};

/**
 * Check if the list is the first list item
 * @param {Node} doc - The document object
 * @param {Node} listItem - The list item node
 * @param {Object} selection - The selection object
 * @returns {boolean} - True if the list is the first list item, false otherwise
 */
const checkIfFirstListItem = (doc, listItem, { from }) => {
    let isFirstListItem = false;

    doc.nodesBetween(0, from, (node) => {
        if (node.type.name === "listItem" && node === listItem) {
            isFirstListItem = true;
            return true;
        } else if (node.type.name === "listItem") {
            isFirstListItem = false;
            return true;
        }
    });

    return isFirstListItem;
};

export { checkIfAfterTable, checkIfFirstListItem };
